import Axios from 'axios';
import Helper from './Helper';

Axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const webAPIURL = () => {
    let baseURL = `${new URL(window.location.origin)}`
    let url = `${baseURL}api`;
    return url
};

const signalRHubURL = () => {
    let baseURL = `${new URL(window.location.origin)}`
    let url = `${baseURL}notificationhub`;
    return url
}

// function getCsrfToken() {
//     return document.cookie
//         .split('; ')
//         .find(row => row.startsWith('NBA-XSRF-TOKEN='))
//         ?.split('=')[1];
// }

const instance = Axios.create({
    withCredentials: true,
    baseURL: webAPIURL(),
    timeout: 1000000,
    // headers: {
    //     'X-NBA-XSRF-TOKEN': Helper.getCookie('NBA-XSRF-TOKEN'),
    // }
})

// Map to track pending requests by URL+method key
const pendingRequests = new Map();

/**
 * Generates a unique key for each request based on method and URL.
 */
const getRequestKey = (method, url) => `${method}:${url}`;

/**
 * If a previous request with the same key exists, cancel it.
 * Then store a new AbortController for the current request.
 */
const cancelPreviousRequest = (requestKey) => {
    if (pendingRequests.has(requestKey)) {
        const prevController = pendingRequests.get(requestKey);
        prevController.abort();
    }
    const controller = new AbortController();
    pendingRequests.set(requestKey, controller);
    return controller.signal;
};

/**
 * Remove the request from the pending map once it completes.
 */
const removePendingRequest = (requestKey) => {
    pendingRequests.delete(requestKey);
};

export default class APIHelper {

    static apiUrl() {
        return webAPIURL();
    }

    static signalRUrl() {
        return signalRHubURL();
    }


    static get(url, headers = {}, obj) {
        const requestKey = getRequestKey('GET', url);
        const signal = cancelPreviousRequest(requestKey);

        return new Promise((resolve, reject) => {
            instance
                .get(url, { headers, signal })
                .then(response => {
                    removePendingRequest(requestKey);
                    resolve(response.data);
                })
                .catch(error => {
                    removePendingRequest(requestKey);
                    if (Axios.isCancel(error)) {
                        console.log('Previous request cancelled:', url);
                        return;
                    }
                    reject(error);
                });
        });
    }

    static post(url, obj, headers = { 'Content-Type': 'application/json', Accept: 'application/json' }) {
        const requestKey = getRequestKey('POST', url);
        const signal = cancelPreviousRequest(requestKey);

        return new Promise((resolve, reject) => {
            instance
                .post(url, obj, { headers, signal })
                .then(response => {
                    removePendingRequest(requestKey);
                    resolve(response.data);
                })
                .catch(error => {
                    removePendingRequest(requestKey);
                    if (Axios.isCancel(error)) {
                        console.log('Previous request cancelled:', url);
                        return;
                    }
                    reject(error);
                });
        });
    }


    static delete(url) {
        const requestKey = getRequestKey('DELETE', url);
        const signal = cancelPreviousRequest(requestKey);

        return new Promise((resolve, reject) => {
            instance
                .delete(url, { signal })
                .then(response => {
                    removePendingRequest(requestKey);
                    resolve(response.data);
                })
                .catch(error => {
                    removePendingRequest(requestKey);
                    if (Axios.isCancel(error)) {
                        console.log('Previous request cancelled:', url);
                        return;
                    }
                    reject(error);
                });
        });
    }
}